import $ from "jquery";
import { getCookie, setCookie } from "../lib/cookies";
import { showModal, isAnyModalOpen } from "./modal-manager";

const cookiename = "showed-onesizedoesnotfit";

// Helper function to validate if a date string is a logically correct date.
// (Copied from the previous script - ensure it's available in this scope)
function isValidDateInternal(dateString) {
  // Assumes dateString has already passed a basic MM/DD/YYYY regex.
  const parts = dateString.split("/");
  const month = parseInt(parts[0], 10); // Month (1-12)
  const day = parseInt(parts[1], 10); // Day
  const year = parseInt(parts[2], 10); // Year

  const dateObj = new Date(year, month - 1, day);

  return (
    dateObj.getFullYear() === year &&
    dateObj.getMonth() === month - 1 &&
    dateObj.getDate() === day
  );
}

function createHubSpotForm() {
  if (typeof hbspt === "undefined") {
    // HubSpot script not loaded, critical for the form to work.
    return;
  }

  // Check if the form already exists to prevent re-creation
  if (
    $("#hsform_onesize").children().length > 0 &&
    $("#hsform_onesize").data("custom-validation-attached")
  ) {
    return;
  }

  const modalFormId = "1e8f7079-b8f6-47bb-aa24-1fc3ee2a690f";

  hbspt.forms.create({
    region: "na1",
    portalId: "21790357",
    target: "#hsform_onesize",
    formId: modalFormId,
    target: "#hsform_onesize",
    formId: modalFormId,
    onFormReady: function ($form) {
      // --- Existing onFormReady logic for this form ---


      // The ZIP field ID for this specific form
      $("#zip-" + modalFormId).attr("maxlength", "5");
      $form.find("#npi__10_digit-" + modalFormId).attr("maxlength", "10");
      $('select[name="specialty"]', $form)
        .find("option")
        .each(function () {
          if (!$(this).val()) {
            $(this).text("Select");
          }
        });
      $("#label-npi__10_digit-" + modalFormId + " span", $form).text("NPI");
      // --- End of existing onFormReady logic ---

      // --- START: New Validation Logic Integration for this modal form ---
      const $submitButton = $form.find(
        'input[type="submit"], button[type="submit"]'
      );
      const $zipField = $form.find("#zip-" + modalFormId);
      const $dobField = $form.find("#date_of_birth-" + modalFormId);
      const $phoneField = $form.find("#phone-" + modalFormId);

      if (!$submitButton.length) {
        return;
        return;
      }

      // Date of Birth (DOB) field handling
      if ($dobField.length) {
        // The HTML snippet shows this placeholder might already be set by HubSpot,
        // but setting it here ensures it if not.
        $dobField.attr("placeholder", "MM/DD/YYYY");

        // Clear initial DOB errors
        $dobField
          .closest(".hs-form-field")
          .find(".custom-form-error.custom-dob-error")
          .remove();
        $dobField.removeClass("custom-field-error");

        // --- Date of Birth (DOB) field handling ---
        if ($dobField.length) {
          $dobField.attr("placeholder", "MM/DD/YYYY");
          // Simplified auto-formatter (same as static form)
          $dobField
            .off("input.dobFormatter")
            .on("input.dobFormatter", function () {
              let value = $(this).val().replace(/\D/g, "");
              if (value.length > 8) value = value.substring(0, 8);
              let formattedValue = "";
              if (value.length > 0) formattedValue = value.substring(0, 2);
              if (value.length > 2)
                formattedValue =
                  value.substring(0, 2) + "/" + value.substring(2, 4);
              if (value.length > 4)
                formattedValue =
                  value.substring(0, 2) +
                  "/" +
                  value.substring(2, 4) +
                  "/" +
                  value.substring(4);
              $(this).val(formattedValue);
            });
        }

        // --- Phone Number field handling ---
        if ($phoneField.length) {
          $phoneField.attr("placeholder", "000-000-0000");
          $phoneField
            .off("input.phoneFormatter")
            .on("input.phoneFormatter", function () {
              let value = $(this).val().replace(/\D/g, "");
              if (value.length > 10) value = value.substring(0, 10);
              let formattedValue = "";
              if (value.length > 0) formattedValue = value.substring(0, 3);
              if (value.length > 3)
                formattedValue =
                  value.substring(0, 3) + "-" + value.substring(3, 6);
              if (value.length > 6)
                formattedValue =
                  value.substring(0, 3) +
                  "-" +
                  value.substring(3, 6) +
                  "-" +
                  value.substring(6);
              $(this).val(formattedValue);
            });
        }
      }

      // Clear initial ZIP errors
      if ($zipField.length) {
        $zipField
          .closest(".hs-form-field")
          .find(".custom-form-error.custom-zip-error")
          .remove();
        $zipField.removeClass("custom-field-error");
      }

      // Attach Submit Button Click Listener for Validations
      $submitButton.off("click.customModalValidation").on("click.customModalValidation", function (event) {
        let isFormValid = true;

        // Clear all previous custom errors
        $form.find(".custom-form-error").remove();
        $form.find(".custom-field-error").removeClass("custom-field-error");

        // --- ZIP VALIDATION ---
        if ($zipField.length) {
          const zipValue = $zipField.val() ? $zipField.val().trim() : "";
          if (zipValue !== "") {
            const usZipRegex = /^\d{5}$/; // Strictly 5 digits
            if (!usZipRegex.test(zipValue)) {
              // Standardized error message
              const errorMessage =
                "Please enter a valid 5-digit US ZIP Code.";
              const $errorElement = $(
                '<label class="hs-error-msg custom-form-error">' +
                errorMessage +
                "</label>"
              );
              $zipField.closest(".input").after($errorElement);
              $zipField.addClass("custom-field-error");
              isFormValid = false;
            }
          }
        }

        // --- PHONE NUMBER VALIDATION ---
        if ($phoneField.length) {
          const phoneValue = $phoneField.val()
            ? $phoneField.val().trim()
            : "";
          if (phoneValue !== "") {
            const phoneDigits = phoneValue.replace(/\D/g, "");
            if (phoneDigits.length !== 10) {
              const errorMessage =
                "Please enter a valid 10-digit US phone number.";
              const $errorElement = $(
                '<label class="hs-error-msg custom-form-error">' +
                errorMessage +
                "</label>"
              );
              $phoneField.closest(".input").after($errorElement);
              $phoneField.addClass("custom-field-error");
              isFormValid = false;
            }
          }
        }

        // --- DATE OF BIRTH VALIDATION ---
        if ($dobField.length) {
          const dobValue = $dobField.val() ? $dobField.val().trim() : "";
          if (dobValue !== "") {
            const dobRegex =
              /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/(19\d{2}|20\d{2})$/;
            if (!dobRegex.test(dobValue)) {
              const errorMessage =
                "Please enter a complete date in MM/DD/YYYY format.";
              const $errorElement = $(
                '<label class="hs-error-msg custom-form-error">' +
                errorMessage +
                "</label>"
              );
              $dobField.closest(".input").after($errorElement);
              $dobField.addClass("custom-field-error");
              isFormValid = false;
            } else if (!isValidDateInternal(dobValue)) {
              const errorMessage =
                "Please enter a valid date (e.g., 04/30/2024 is valid, but 04/31/2024 is not).";
              const $errorElement = $(
                '<label class="hs-error-msg custom-form-error">' +
                errorMessage +
                "</label>"
              );
              $dobField.closest(".input").after($errorElement);
              $dobField.addClass("custom-field-error");
              isFormValid = false;
            }
          }
        }

        if (!isFormValid) {
          event.preventDefault();
        }
      });

      $("#hsform_onesize").data("custom-validation-attached", true);
    },
    onFormSubmit: function ($form) {
      $form.on("submit", function (e) {
        e.preventDefault();
      });
    },
    onFormValidation: function ($form, errors) {
      const formName = $form.attr("name") || $form.attr("id") || "hsForm";
      errors.forEach((err) => {
        window.dataLayer = window.dataLayer || [];
        console.log("validation error", {
          event: "validation_errors",
          event_action: formName,
          event_label: `${err.field.name}_${err.errorType}`,
          full_url: window.location.href,
        });
        window.dataLayer.push({
          event: "validation_errors",
          event_action: formName,
          event_label: `${err.field.name}_${err.errorType}`,
          full_url: window.location.href,
        });
      });
    },
    onFormSubmitted: function ($form) {
      const formName = $form.attr("name") || $form.attr("id") || "hsForm";
      window.dataLayer?.push({
        event: "pop_up_subscription",
        page_name: "pop_up_completion",
      });
      console.log("form submitted", {
        event: "form_submissions",
        event_action: formName, // $FormName
        event_label: "Complete", // literal "Complete"
      });
      window.dataLayer?.push({
        event: "form_submissions",
        event_action: formName, // $FormName
        event_label: "Complete", // literal "Complete"
      });
      // The original scroll logic might need $form.closest('.modal-content') or similar if '.modal-body' isn't the direct scrollable parent.
      // For now, keeping it as is.
      const $modalBody = $form.closest(".modal-body");
      if ($modalBody.length && $form.length) {
        // scrollTop expects a number, not a jQuery object. .offset().top gives position relative to document.
        // To scroll within modal-body, you might need position relative to modal-body or just scroll to top of form within modal.
        // A simpler scroll to the top of the form within its container:
        if ($form.get(0) && $modalBody.get(0)) {
          $modalBody.scrollTop(
            $modalBody.scrollTop() +
            $form.offset().top -
            $modalBody.offset().top
          );
        }
      }
    },
  });

  // The second form initialization for "hsform_onesize_id" (d31e8c18-...)
  // is left untouched by these specific ZIP/DOB validations.
  // If it also needs them, similar integration would be required for its onFormReady.
  if (
    $("#hsform_onesize_id").children().length > 0 &&
    $("#hsform_onesize_id").data("custom-validation-attached")
  ) {
    return;
  }

  hbspt.forms.create({
    region: "na1",
    portalId: "21790357",
    target: "#hsform_onesize_id",
    formId: "d31e8c18-1822-46ff-a910-5b3917374dba",
    onFormReady: function ($form) {
      // Original onFormReady for the second form
      $("#zip-d31e8c18-1822-46ff-a910-5b3917374dba").attr("maxlength", "5");
      $form
        .find("#npi__10_digit_-d31e8c18-1822-46ff-a910-5b3917374dba")
        .attr("maxlength", "10");
      $('select[name="specialty"]', $form)
        .find("option")
        .each(function () {
          if (!$(this).val()) {
            $(this).text("Select");
          }
        });
      $(
        "#label-npi__10_digit_-d31e8c18-1822-46ff-a910-5b3917374dba span",
        $form
      ).text("NPI");
      $("#hsform_onesize_id").data("custom-validation-attached", true); // Mark as processed
    },
    onFormSubmit: function ($form) {
      $form.on("submit", function (e) {
        e.preventDefault();
      });
    },
    onFormSubmitted: function ($form) {
      window.dataLayer?.push({
        event: "pop_up_subscription",
        page_name: "pop_up_completion",
      });
      const $modalBody = $form.closest(".modal-body");
      if (
        $modalBody.length &&
        $form.length &&
        $form.get(0) &&
        $modalBody.get(0)
      ) {
        $modalBody.scrollTop(
          $modalBody.scrollTop() + $form.offset().top - $modalBody.offset().top
        );
      }
    },
  });
}

$(function () {
  // General escape condition, kept for safety.
  if (window.skipexternal) {
    return;
  }

  // Create HubSpot forms on page load.
  // This is crucial to ensure modal content is ready when needed.
  createHubSpotForm();

  const cookiename = "showed-onesizedoesnotfit";
  // Flag to ensure the modal sequence is initiated only once.
  let isModalSequenceInitiated = false;

  /**
   * CORE FUNCTION: Initiates the sequence to display the modal.
   * Contains the timer logic and verifications.
   */
  function startModalSequence() {
    // If the sequence has already been initiated, do nothing more.
    // If the sequence has already been initiated, do nothing more.
    if (isModalSequenceInitiated) {
      return;
    }
    // Set the flag to block future executions.
    isModalSequenceInitiated = true;

    console.log("Cookie consent detected. Starting 10-second modal timer.");

    // Start the 10-second timer.
    // Start the 10-second timer.
    setTimeout(function () {
      // After 10 seconds, we don't show the modal immediately.
      // We first ensure the HubSpot script is loaded.
      pollForHubspotAndShowModal();
      // After 10 seconds, we don't show the modal immediately.
      // We first ensure the HubSpot script is loaded.
      pollForHubspotAndShowModal();
    }, 10000); // 10,000 milliseconds = 10 seconds
  }

  // --- MAIN LOGIC ON PAGE LOAD ---

  // First, check if the user has already seen the modal in a recent visit.
  const cookieValue = getCookie(cookiename);
  if (cookieValue === "true") {
    // If the cookie already exists, do nothing. The user will not be interrupted.
    return;
  }

  // If the user is new or the cookie has expired, set up the triggers.

  /**
   * TRIGGER #1: COOKIE ACCEPTANCE (COOKIEBOT CALLBACK)
   * Cookiebot will look for and execute this global function when the user clicks "Accept".
   */
  window.CookiebotCallback_OnAccept = function () {
    startModalSequence();
  };

  /**
   * TRIGGER #2: USER SCROLL (IMPLICIT ACCEPTANCE)
   * We use jQuery's .one() so this event only fires once.
   */
  $(window).one("scroll", function () {
    // Check with Cookiebot if consent has been granted (important for implicit acceptance on scroll).
    if (typeof Cookiebot !== "undefined" && Cookiebot.consented) {
      startModalSequence();
    }
  });

  function pollForHubspotAndShowModal() {
    const maxWaitTime = 8000; // Max time to wait for HubSpot script (8 seconds).
    const pollInterval = 100; // Check every 100ms.
    let elapsedTime = 0;

    const intervalId = setInterval(function () {
      // Check if the HubSpot forms object is now available on the window.
      if (typeof hbspt !== "undefined" && typeof hbspt.forms !== "undefined") {
        // SUCCESS! HubSpot is ready.
        clearInterval(intervalId); // Stop polling.
        console.log("HubSpot script confirmed loaded. Preparing modal.");

        // Now we can safely execute the final steps.
        setCookie(cookiename, "true", 7);
        if (!isAnyModalOpen()) {
          // Ensure the form is created right before showing the modal.
          createHubSpotForm();
          showModal("#modal_onesizedoesnotfit");
        }
        return;
      }

      elapsedTime += pollInterval;

      // Check if we've waited too long.
      if (elapsedTime >= maxWaitTime) {
        // FAILURE. HubSpot script did not load in time.
        clearInterval(intervalId); // Stop polling.
        console.error(
          "HubSpot script did not load within the " +
          maxWaitTime / 1000 +
          "s timeframe."
        );
        // In this case, we simply do not show the modal to avoid a bad user experience.
      }
    }, pollInterval);
  }
});
